import { type FC, useMemo } from 'react';

import { REQUEST_HEADER_VERSION } from '@/apis/request';
import useAppTitle from '@/hooks/useTitle';
import { getAppChannelValue, EAPP_CHANNEL_VALUE } from '@/channels';
import styles from './styles/page.module.less';

const MCD_ICON = 'https://img.mcd.cn/gallery/f9504f92604c84af.jpeg';

const CASE_NUM_MAP: Partial<Record<EAPP_CHANNEL_VALUE, string>> = {
  [EAPP_CHANNEL_VALUE.DOUYIN]: '沪ICP备06017533号-58X',
  [EAPP_CHANNEL_VALUE.UNIONPAY]: '沪ICP备06017533号-39X',
};

const AboutMCD: FC = () => {
  useAppTitle({
    title: '关于麦当劳',
    navBackgroundColor: 'FFFFFFFF',
    appletStyle: 'black',
    backBtnVisible: '1',
    appletTitleBarVisible: '1',
  });

  const appVersion = REQUEST_HEADER_VERSION;
  const commitHash = useMemo(() => {
    const hash = process.env.COMMIT_HASH;
    if (hash && typeof hash === 'string') return hash.slice(0, 7);
    return undefined;
  }, []);

  const caseNum = useMemo(() => {
    const channel = getAppChannelValue();
    return CASE_NUM_MAP[channel];
  }, []);

  return (
    <div>
      <div className={styles.header}>
        <img className={styles.mcd_logo} src={MCD_ICON} />
        {appVersion && (
          <p className={styles.version}>
            v{appVersion}
            {commitHash && <span style={{ marginLeft: '8px' }}>(build {commitHash})</span>}
          </p>
        )}
      </div>
      {caseNum && (
        <div className={styles.item}>
          <div className={styles.item_name}>备案号</div>
          <div className={styles.item_sub}>{caseNum}</div>
        </div>
      )}
    </div>
  );
};

export default AboutMCD;
